"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightOfferStatus = exports.initialAircraft = exports.initialLicenseState = exports.initialChangePasswordState = exports.stackScreens = exports.FlightStatus = void 0;
var FlightStatus;
(function (FlightStatus) {
    FlightStatus[FlightStatus["NEW"] = 1] = "NEW";
    FlightStatus[FlightStatus["OPEN"] = 2] = "OPEN";
    FlightStatus[FlightStatus["CLOSED"] = 3] = "CLOSED";
    FlightStatus[FlightStatus["DONE"] = 4] = "DONE";
    FlightStatus[FlightStatus["CANCELED"] = 5] = "CANCELED";
})(FlightStatus || (exports.FlightStatus = FlightStatus = {}));
exports.stackScreens = {
    HomeStack: ["Home", "FlightDetails", "PublishSuccess", "RequestDetails", "OfferFlightSuccess"],
    MyFlightsStack: ["MyFlights", "MyFlightDetails", "MyRequestDetails", "CancelFlightSuccess"],
    MessagesStack: ["Messages"],
    AccountStack: ["Account"]
};
exports.initialChangePasswordState = {
    oldPassword: '',
    newPassword: '',
    repeatedPassword: ''
};
exports.initialLicenseState = {
    flied_hours: null,
    number: '',
    types: [],
    company: ''
};
exports.initialAircraft = {
    id: '',
    reg_number: '',
    manufacturer: '',
    model: '',
    type: '',
    serial_number: ''
};
var FlightOfferStatus;
(function (FlightOfferStatus) {
    FlightOfferStatus[FlightOfferStatus["PENDING"] = 1] = "PENDING";
    FlightOfferStatus[FlightOfferStatus["ACCEPTED"] = 2] = "ACCEPTED";
    FlightOfferStatus[FlightOfferStatus["DECLINED"] = 3] = "DECLINED";
})(FlightOfferStatus || (exports.FlightOfferStatus = FlightOfferStatus = {}));
